<template>
    <div class="FieldHelpWrap">
        <div class="FieldHelpWrap__input">
            <v-textarea
                label="Testimonial"
                outlined
                name="testimonial"
                v-model="testimonial"
                @change="setFieldData"
            />

            <v-text-field
                label="Name, Location/Position"
                outlined
                name="attestor"
                v-model="attestor"
                @change="setFieldData"
            />
        </div>
        <div
            class="FieldHelpWrap__help"
            v-if="helpText"
        >
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </div>
    </div>
</template>

<script>

import store from '@/store/store';
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';

export default {
    mixins: [SubmissionBoilerplate],

    data() {
        return {
            testimonial: '',
            attestor: '',
        };
    },

    computed: {
        card() {
            return store.state[this.fieldNamespace].card;
        },

        loadStock() {
            return store.state[this.fieldNamespace].options.loadStock;
        },

        stockMedia() {
            return store.state[this.fieldNamespace].stockMedia;
        },

        uploadType() {
            return store.state[this.fieldNamespace].options.uploadType;
        },

        userMedia() {
            return store.state[this.fieldNamespace].userMedia;
        },
    },

    methods: {
        loadFieldData() {
            if (this.submission && this.submission.data) {
                this.testimonial = this.submission.data.testimonial;
                this.attestor = this.submission.data.attestor;
            }

            this.setFieldData();
        },

        setFieldData()
        {
            this.fieldData = {
                data: {
                    testimonial: this.testimonial,
                    attestor: this.attestor,
                },
            };

            this.storeFieldData();
        },
    }
};
</script>
